export default __webpack_public_path__ + "static/media/alejandro_loguercio_max_steiner_tuning.7a6d3479.jpg";